import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const CONTACT_URL =
  (process.env.REACT_APP_API_DOMAIN || '') + '/ContactPHP/contact.php';

export const submitContactForm = createAsyncThunk(
  'contact/submit',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(CONTACT_URL, {
        ...formData,
        source: 'contact',
      });
      if (response.data && response.data.status === 'error') {
        return rejectWithValue(response.data.message || 'Verification failed');
      }
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      return rejectWithValue(msg);
    }
  }
);

const contactSlice = createSlice({
  name: 'contact',
  initialState: {
    status: 'idle',   // 'idle' | 'loading' | 'success' | 'error'
    message: '',
  },
  reducers: {
    resetContact: (state) => {
      state.status = 'idle';
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.status = 'loading';
        state.message = '';
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.status = 'success';
        state.message = action.payload?.message || "Your message has been sent! We'll get back to you shortly.";
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.status = 'error';
        state.message = action.payload || 'Something went wrong.';
      });
  },
});

export const { resetContact } = contactSlice.actions;
export default contactSlice.reducer;
